import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  termsAndConditionsText: {
    fontSize: theme.spacing(6),
    lineHeight: '18px',
    letterSpacing: '0.12px',

    '& a': {
      color: '#01B2AE',
      lineHeight: '12px',

      '&:not(:last-child)': {
        textDecoration: 'none',
      },
    },
  },
}));
